import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { StandSelector } from "./StandSelector";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface BarrelsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	standId: number | null;
	onStandChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const BarrelsToolbar = ({
	search,
	onSearchChange,
	standId,
	onStandChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: BarrelsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				px: 1.5,
				py: 0.5,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<StandSelector
				value={standId}
				onChange={onStandChange}
				includeAll
				sx={{ width: 160 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD BARREL
			</Button>
		</Box>
	);
};
